import { useEffect, useState } from "react";

import Loading from "@/components/Loading";
import { useOrganisationContext } from "@/contexts/organisations/OrganisationContext";
import { ORGANISATION_STOCK_BASKET_QUERY } from "@/graphql/organisations/queries/stock";
import { useDataLoader } from "@/hooks/useDataLoader";

import DownloadRequisitionPanel from "./DownloadRequisition";
import RegisterStockPanel from "./RegisterStockPanel";

export default function RegisterStock({
  stockId,
  showCreatePatientForm,
  setShowCreatePatientForm,
  showEditPatientForm,
  setShowEditPatientForm
}) {
  const [registrationComplete, setRegistrationComplete] = useState(false);

  const { organisation } = useOrganisationContext();
  const { data, loading } = useDataLoader({
    query: ORGANISATION_STOCK_BASKET_QUERY,
    variables: {
      stockId,
      organisation: parseInt(organisation?.id)
    },
    skip: !organisation || !stockId,
    fetchPolicy: "network-only",
    nextFetchPolicy: "cache-only"
  });

  const stockBasket = data?.stockBasket;
  const stockLineItem = stockBasket?.productLineItems[0];
  const stock = stockLineItem?.stockItem;

  useEffect(() => {
    if (stock?.registeredUser) {
      setRegistrationComplete(true);
    }
  }, [stock?.registeredUser]);

  if (loading || !stock) {
    return <Loading />;
  }

  if (registrationComplete) {
    return <DownloadRequisitionPanel stock={stock} />;
  }

  return (
    <RegisterStockPanel
      stockBasket={stockBasket}
      stock={stock}
      onComplete={() => setRegistrationComplete(true)}
      showCreatePatientForm={showCreatePatientForm}
      setShowCreatePatientForm={setShowCreatePatientForm}
      showEditPatientForm={showEditPatientForm}
      setShowEditPatientForm={setShowEditPatientForm}
    />
  );
}
